import * as React from "react";

export const PageNotFound = props => (
  <div>
    <h1>Page Not Found</h1>
  </div>
);
